
  import { Component, Prop } from 'vue-property-decorator'
  import { VBtn } from 'vuetify/lib'

  @Component
  export default class PagesBtn extends VBtn {
    @Prop({ type: String, default: 'success' }) private readonly color!: string
    @Prop({ type: Boolean, default: false }) private readonly depressed!: boolean
    @Prop({ type: Boolean, default: true }) private readonly default!: boolean
    @Prop({ type: Boolean, default: true }) private readonly rounded!: boolean
  }
